"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, useMemo } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppConfigProvider } from "@/lib/config";
import { playgroundMessages } from "@/messages";
import { I18nProvider } from "@llmgateway/i18n/react";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}
export function Providers(t0) {
  const $ = _c(16);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 300000,
          retry: false
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  let t3;
  if ($[1] !== config.posthogHost || $[2] !== config.posthogKey) {
    t2 = () => {
      if (!config.posthogKey) {
        return;
      }
      const key = config.posthogKey;
      const host = config.posthogHost;
      const init = () => {
        posthog.init(key, {
          api_host: host,
          capture_pageview: "history_change",
          autocapture: true
        });
      };
      if (typeof requestIdleCallback !== "undefined") {
        const id = requestIdleCallback(init);
        return () => cancelIdleCallback(id);
      }
      const timer = setTimeout(init, 1000);
      return () => clearTimeout(timer);
    };
    t3 = [config.posthogKey, config.posthogHost];
    $[1] = config.posthogHost;
    $[2] = config.posthogKey;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== children) {
    t4 = <PostHogProvider client={posthog}>{children}</PostHogProvider>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = process.env.NODE_ENV === "development" && <ReactQueryDevtools buttonPosition="top-right" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <QueryClientProvider client={queryClient}>{t4}{t5}</QueryClientProvider>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Toaster />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <I18nProvider messages={playgroundMessages}><ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t6}{t7}</ThemeProvider></I18nProvider>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== config || $[14] !== t8) {
    t9 = <AppConfigProvider config={config}>{t8}</AppConfigProvider>;
    $[13] = config;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}